import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { sendRequest, triggerEvent } from '../helpers/global.js';

import '../sass/components/WeekView.scss';

const mapStoreToProps = (store) => {
  return {
    isMobile: store.setup.isMobile,
  }
};

class WeekView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [],
      selected: {},
      collapsed: {},
    }
    this.savedTimeout = null;
  }

  componentDidMount = () => {
    this.requestMenu();
    this.requestOrders();
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.props.week !== prevProps.week) {
      this.requestMenu();
      this.requestOrders();
    }
  }

  requestMenu = () => {
    sendRequest({
      method: 'menu',
      type: 'GET',
      data: {
        week: this.props.week || 'current',
      },
      success: (data) => {
        this.setState({menu: data, collapsed: {}});
      },
      error: (data) => {
      }
    });
  }

  requestOrders = () => {
    sendRequest({
      method: 'orders',
      type: 'GET',
      data: {
        week: this.props.week || 'current',
      },
      success: (data) => {
        const selected = {};
        data.forEach(day => {
          selected[day.date] = {};
          day.items.forEach(item => {
            selected[day.date][item.dish.id] = Number(item.qnt) || 0;
          })
        });
        this.setState({selected});
      },
      error: (data) => {
      }
    });
  }

  onSave = () => {
    Object.keys(this.state.selected).forEach(date => {
      const items = [];
      Object.keys(this.state.selected[date]).forEach(itemId => {
        const qnt = this.state.selected[date][itemId] || 0
        if (qnt > 0) {
          items.push({dish_id: itemId, qnt});
        }
      });
      sendRequest({
        method: 'orders',
        type: 'POST',
        data: {
          date,
          items,
        },
        success: (data) => {
          triggerEvent('showSnackbar', [{text: 'Сохранено!', type: 'success'}]);  
          clearTimeout(this.savedTimeout);
          this.savedTimeout = setTimeout(() => {
            triggerEvent('updateTotals');
          }, 250);
        },
        error: (data) => {
        }
      });
    });
  }

  getSelectedQnt = (date, id) => {
    return this.state.selected[date] ? this.state.selected[date][id] || 0 : 0
  }

  renderFoodInput = (date, id, value, available) => {
    const isNextWeek = this.props.week === 'next';
    if (isNextWeek && available) {
      return (
        <div className='foodInput'>
          <button
            className='foodInputMinus'
            onClick={() => this.setState({
              selected: {
                ...this.state.selected,
                [date]: {
                  ...this.state.selected[date],
                  [id]: Math.max(value - 1, 0),
                }
              }
            })}
          >-</button>
          <div className='foodCount'>{value}</div>
          <button
            className='foodInputPlus'
            onClick={() => this.setState({
              selected: {
                ...this.state.selected,
                [date]: {
                  ...this.state.selected[date],
                  [id]: Math.min(value + 1, 99),
                }
              }
            })}
          >+</button>
        </div>
      )
    } else {
      return (
        <div className='foodInput'>
          <div className='foodCount'>{value}</div>
        </div>
      )
    }
  }

  getDishesForDay = (day) => {
    const isNextWeek = this.props.week === 'next';
    if (isNextWeek) {
      return day.dishes;
    } else {
      return day.dishes.filter(d => this.getSelectedQnt(day.date, d.id) > 0);
    }
  }

  getSummaryForDay = (day) => {
    const SUM_KEYS = ['proteins', 'fats', 'carbs', 'calories', 'price'];
    const dishes = this.getDishesForDay(day);
    const summary = {};

    SUM_KEYS.forEach(key => summary[key] = 0);
    dishes.forEach(dish => {
      const qnt = this.getSelectedQnt(day.date, dish.id);
      SUM_KEYS.forEach(key => summary[key] += qnt * dish[key]);
    });
    SUM_KEYS.forEach(key => summary[key] = Math.round(summary[key] * 100) / 100);
    return summary;
  }
  
  renderDayDishes = (day) => {
    const isNextWeek = this.props.week === 'next';
    const dishes = this.getDishesForDay(day);
    if (dishes.length === 0) {
      return (
        <div className='dishesPlaceholder'>Нет блюд</div>
      )
    };
    const summary = this.getSummaryForDay(day);
    return (
      <div className='dayDishes'>
        <table className='foodTable'>
          <thead>
            {this.props.isMobile ?
              <tr>
                <th width='100%'>Название</th>
                <th width='140px'>Кол-во</th>
              </tr>
              :
              <tr>
                <th width='70px'>№ п/п</th>
                <th width='auto'>Название</th>
                <th width='60px'>Б</th>
                <th width='60px'>Ж</th>
                <th width='60px'>У</th>
                <th width='60px'>К</th>
                <th width='120px'>Вес</th>
                <th width='120px'>Цена</th>
                <th width='140px'>Кол-во</th>
              </tr>
            }
          </thead>
          <tbody>
            {dishes.map(food => {
              const value = this.getSelectedQnt(day.date, food.id);
              if (this.props.isMobile) {
                return (
                  <tr
                    key={food.id}
                    className={classnames({
                      'selected': isNextWeek && value > 0
                    })}
                  >
                    <td className='name'>{food.name}</td>
                    <td>{this.renderFoodInput(day.date, food.id, value, day.available)}</td>
                  </tr>
                )
              } else {
                return (
                  <tr
                    key={food.id}
                    className={classnames({
                      'selected': isNextWeek && value > 0
                    })}
                  >
                    <td>{food.position}</td>
                    <td className='name'>{food.name}</td>
                    <td>{food.proteins}</td>
                    <td>{food.fats}</td>
                    <td>{food.carbs}</td>
                    <td>{food.calories}</td>
                    <td>{food.weight}</td>
                    <td className='price'><b>{food.price}</b> p</td>
                    <td>{this.renderFoodInput(day.date, food.id, value, day.available)}</td>
                  </tr>
                )
              }
            })}
            {this.props.isMobile ?
              <tr className='summary'>
                <td className='name'><b>Итого</b></td>
                <td className='price'><b>{summary.price}</b> p</td>
              </tr>
              :
              <tr className='summary'>
                <td></td>
                <td className='name'><b>Итого</b></td>
                <td>{summary.proteins}</td>
                <td>{summary.fats}</td>
                <td>{summary.carbs}</td>
                <td>{summary.calories}</td>
                <td></td>
                <td className='price'><b>{summary.price}</b> p</td>
                <td></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    )
  }

  renderDay = (day) => {
    const collapsed = this.state.collapsed[day.date];
    return (
      <div id={day.date} key={day.date} className='dayItem'>
        <div
          className='dayDate'
          onClick={() => {
            this.setState({
              collapsed: {
                ...this.state.collapsed,
                [day.date]: !collapsed,
              }
            });
          }}
        >
          {moment(day.date).format('ddd DD.MM')}
          <div className='dayArrow'>{collapsed ? '▼' : '▲'}</div>
        </div>
        {collapsed ? null : this.renderDayDishes(day)}
      </div>
    )
  }

  scrollToDate = (date) => {
    const el = document.getElementById(date);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  renderNav = () => {
    const isNextWeek = this.props.week === 'next';
    const daySummary = {};
    this.state.menu.forEach(day => daySummary[day.date] = this.getSummaryForDay(day));
    const totalPrice = Object.values(daySummary).reduce((acc, day) => acc + day.price, 0);
    return (
      <div className='navContainer'>
        <div className='navItems'>
          {this.state.menu.map(day => {
            return (
              <div
                className='navItem'
                key={day.date}
                onClick={() => this.scrollToDate(day.date)}
              >
                <div className='navDate'>{moment(day.date).format('ddd DD.MM')}</div>
                <div className='navPrice'><b>{daySummary[day.date].price}</b> р</div>
              </div>
            )}
          )}
          <div className='navTotal'>
            <div className='totalTitle'>Итого</div>
            <div className='totalPrice'><b>{totalPrice}</b> р</div>
          </div>
        </div>
        {isNextWeek ?
          <button onClick={this.onSave}>Сохранить</button>
        : null}
      </div>
    )
  }

  render = () => {
    const isNextWeek = this.props.week === 'next';
    return (
      <div className='weekView'>
        <div className='weekTitle'>
          {isNextWeek ? 'Заказ на следующую неделю' : 'Текущая неделя'}
        </div>
        {this.renderNav()}
        {this.state.menu.map(day => this.renderDay(day))}
      </div>
    )
  }
}

export default connect(mapStoreToProps)(withRouter(WeekView))
